class ScrollingFeaturesBar {
  constructor() {
    this.tracks = new Map();
    this.frame = 0;
    this.onResize = () => this.scheduleAdjust();
    this.init();
  }

  init() {
    const start = () => {
      this.setup();
      window.addEventListener('resize', this.onResize, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleAdjust());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  setup() {
    document.querySelectorAll('.features-track').forEach((track) => {
      if (this.tracks.has(track)) return;

      const container = track.closest('.features-track-container');
      const items = track.querySelector('.feature-items');
      const section = track.closest('[class*="section-"]');
      if (!container || !items) return;

      if (section && section.classList.contains('pause-on-hover')) {
        track.addEventListener('mouseenter', () => {
          track.style.animationPlayState = 'paused';
        });
        track.addEventListener('mouseleave', () => {
          track.style.animationPlayState = 'running';
        });
      }

      this.tracks.set(track, { container, items });
    });

    this.adjust();
  }

  scheduleAdjust() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.adjust();
    });
  }

  adjust() {
    this.tracks.forEach(({ container, items }, track) => {
      const itemsWidth = items.offsetWidth;
      const itemsHeight = items.offsetHeight;
      if (itemsWidth) {
        const width = `${itemsWidth * 4}px`;
        if (track.style.width !== width) track.style.width = width;
      }
      if (itemsHeight) {
        const height = `${itemsHeight}px`;
        if (container.style.height !== height) container.style.height = height;
      }
    });
  }
}

new ScrollingFeaturesBar();
